var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'anx-button': true,
    inline: _vm.inline !== null,
    'btn-outline': _vm.outline !== null
  },style:(_vm.cssProps),attrs:{"type":_vm.btnType},on:{"click":function($event){return _vm.$emit(_vm.eventName)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }